const url = window.location.hostname
const host = window.location.protocol
const prodDomainSuffix = '.bloo.io'
const prodLogEndpointDomainSuffix = '.bridge.bloo.io'
const devLogEndpointDomain = 'alpha-bridge.dnifuat.com' // TODO: Subject to change in future
const prodLogEndpointDomain = getLogEndpointDomain() || devLogEndpointDomain

function getLogEndpointDomain() {
  let logEndpointDomain = ''
  if (url.endsWith(prodDomainSuffix)) {
    let parts = url.split('.')
    logEndpointDomain = `${parts[0]}${prodLogEndpointDomainSuffix}`
  }

  return logEndpointDomain
}

const Conf = {
  HOST_S: url === 'localhost' ? 'https://' : host + '//',
  HOST: url === 'localhost' ? 'https://' : host + '//',
  CORE_IP: url === 'localhost' ? 'n953.dnifuat.com' : url,
  CORE_IP2: url === 'localhost' ? 'n953.dnifuat.com' : url,
  CORE_IP3: url === 'localhost' ? 'n953.dnifuat.com' : url,
  // CORE_IP2: '64.227.140.206',
  LC_IP: url === 'localhost' ? 'n953.dnifuat.com' : url,
  PORT_1: url === 'localhost' ? '' : '',
  PORT_2: url === 'localhost' ? '' : '',
  PORT_3: url === 'localhost' ? '' : '',
  PORT_4: url === 'localhost' ? '' : '',
  UNET_IP: url === 'localhost' ? 'n953.dnifuat.com' : url,
  parserIP: url === 'localhost' ? 'n953.dnifuat.com' : url,

  LOG_ENDPOINT_DOMAIN: prodLogEndpointDomain,

  // Feature flag: set REACT_APP_CUSTOMER_STATS_ENABLED=true at build time to show
  // System > Customer Stats (Root only). Off by default.
  CUSTOMER_STATS_ENABLED: process.env.REACT_APP_CUSTOMER_STATS_ENABLED === 'true',

  // Feature flag: set REACT_APP_CUSTOMER_STATS_TENANT_ENABLED=true (together with
  // CUSTOMER_STATS_ENABLED) to also open Customer Stats to tenant admins as
  // "Usage & health". lc-api must also run with STATS_TENANT_ADMIN_ENABLED=true. Off by default.
  CUSTOMER_STATS_TENANT_ENABLED: process.env.REACT_APP_CUSTOMER_STATS_TENANT_ENABLED === 'true',

  // Grafana base URL (e.g. https://grafana.example.com) for the Customer Stats
  // "Open in Grafana" link. Set REACT_APP_GRAFANA_URL at build time; no default,
  // and the link is hidden unless it is an https:// URL (CS-07).
  GRAFANA_URL: process.env.REACT_APP_GRAFANA_URL || '',
}
export default Conf
